module.exports = "<div class=\"fakeBlock-20\"></div>\n<div class=\"row\">\n  <div class=\"col-sm-12 col-md-8\">\n    <div class=\"card\">\n      <div class=\"card-body\">\n        <pre>{{ proyectQr | json }}</pre>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-sm-12 col-md-4\">\n    <div class=\"card\">\n      <div class=\"card-body\">\n        added and change data\n      </div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dash/carpeta/carpeta.component.html
// module id = ./src/app/pages/dash/carpeta/carpeta.component.html
// module chunks = main